export default __webpack_public_path__ + "static/126-6da763dfa02dd2b0b7f9b02490087424.jpg";